import { useState } from "react";
import { useNavigate } from "react-router-dom";
import "../assets/css/pages/login.css";

const AdminLogin: React.FC = () => {
  const navigate = useNavigate();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleLogin = async (e: React.FormEvent) => {

    e.preventDefault();
    setError("");
    setLoading(true);

    try {
      const response = await fetch(
        `${import.meta.env.VITE_LYRAZONE_BASE_URL}/admin/login`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          credentials: "include",
          body: JSON.stringify({
            email,
            password,
          }),
        },
      );

      const data = await response.json();

      if (!data.success) {
        setError(data.message || "Login failed");
        setLoading(false);
        return;
      }

      // ✅ Store admin user in localStorage
      // Make sure backend returns user object (see note below)
      if (data.admin) {
        localStorage.setItem(
          "admin_user",
          JSON.stringify({
            ...data.admin,
            tokenExpiry: data.tokenExpiry,
          }),
        );
      }

      // Redirect
      navigate("/admin");
    } catch (err) {
      setError("Server error. Please try again.");
    }

    setLoading(false);
  };

  return (
    <div
      className="hero-area"
      style={{ position: "fixed", width: "100%", marginTop: "-110px" }}
    >
      <div className="overlay"></div>
      <div className="container">
        <div className="row">
          <div className="col-md-12">
            <div className="login-contact-h-cont">
              <h3 className="text-center">
                <img
                  style={{ width: "150px" }}
                  src="/images/Lyra-Zone-Logo-New.png"
                  className="img-fluid"
                  alt="Logo"
                />
              </h3>

              <br />

              {error && (
                <div style={{ color: "red", marginBottom: "10px" }}>
                  {error}
                </div>
              )}

              <form onSubmit={handleLogin}>
                <div className="form-group">
                  <label>Email</label>
                  <input
                    type="email"
                    className="form-control"
                    placeholder="Enter Email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                  />
                </div>

                <div className="form-group">
                  <label>Password</label>
                  <input
                    className="form-control"
                    type="password"
                    placeholder="Enter Password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    required
                  />
                </div>

                <button
                  className="btn btn-general btn-blue"
                  type="submit"
                  disabled={loading}
                >
                  {loading ? "Logging in..." : "Login"}
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminLogin;
